import React from "react";
import PropTypes from "prop-types";
import {
  Text,
  Popover,
  POPOVER_ORIENTATION,
  POPOVER_POSITION,
  BADI_COLORS,
} from "@badi/badi-components";
import { TextWrapper } from "./styled-components";

const Message = ({ message = null }) =>
  message ? (
    <Popover
      backgroundColor={BADI_COLORS.NEUTRAL.NEUTRAL_05}
      orientation={POPOVER_ORIENTATION.UP}
      position={POPOVER_POSITION.LEFT}
      shadow={false}
    >
      <TextWrapper>
        <Text body="14-Regular" dataQa="enquiry-message">
          {message}
        </Text>
      </TextWrapper>
    </Popover>
  ) : null;

Message.propTypes = {
  message: PropTypes.string,
};

export default Message;
